import * as React from 'react';
import {useState} from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import CommonAppbar from '../components/common/CommonAppbar';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {CONTENT_LANGUAGES, URLS} from '../constants/appConstants';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import DeveloperInfo from '../components/common/DeveloperInfo';
import CountrySelect from './CountrySelection';


export default function ContentLanguageSelection() {

  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [selectedCountry, setSelectedCountry] = useState()
  const isSignInPage = searchParams.get('signIn') === 'true'
  const [checked, setChecked] = React.useState([CONTENT_LANGUAGES.ENGLISH]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  return (
    <>
      <CommonAppbar isMainPage={false} pageHeader={'Country and Language'}/>
      <DeveloperInfo> Do not proceed without Country Selection.</DeveloperInfo>
      <Typography variant="h5" component="h6">
        Get better results
      </Typography>

      <CountrySelect selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry}/>

      {selectedCountry && selectedCountry.code === 'IN' &&
        <>
          <DeveloperInfo> This selection is applicable only for countries(Like India) which support multiple languages.
            Be default <b>english</b> checkbox should be selected and disable it.
            If language selection is not available for a country, hide language selection section and set default
            to <b>english</b>.
          </DeveloperInfo>
          <Typography variant="body2" gutterBottom>
            Select your preferred content language. Select the ones which you can read/understand.
          </Typography>

          <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
            {Object.entries(CONTENT_LANGUAGES).map(([key, value]) => {
              const labelId = `checkbox-list-label-${value}`;
              return (
                <ListItem key={value}>
                  <ListItemButton role={undefined} onClick={handleToggle(value)} dense
                                  disabled={value === CONTENT_LANGUAGES.ENGLISH}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{'aria-labelledby': labelId}}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={`${value}`}/>
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </>
    }
      <Box sx={{minWidth: 120}}>
        <FormControl fullWidth sx={{mt: 2}}>
          <Button variant="contained" onClick={() => navigate(`${isSignInPage ? URLS.CATEGORY : URLS.PROFILE}`)}>
            Save
          </Button>
        </FormControl>

      </Box>
    </>
  )
    ;
}
